import { useLanguage } from '../i18n';
import { TechDiagram } from '../components/TechDiagram';
import { Reveal } from '../components/Reveal';
import { Overline } from '../components/Overline';
import { PageHero } from '../components/PageHero';
import { CTASection } from '../components/CTASection';

const About = () => {
  const { t } = useLanguage();

  return (
    <div data-testid="about-page" className="pt-16">
      <section className="relative overflow-hidden">
        <TechDiagram
          variant="gear"
          className="pointer-events-none absolute -right-36 top-24 aspect-square w-[460px] opacity-30"
        />
        <div className="mx-auto max-w-7xl px-6 py-24">
          <PageHero
            overline={t.about.overline}
            title={t.about.title}
            intro={t.about.intro}
            titleClassName="max-w-3xl"
            introClassName="max-w-xl"
          />

          <div className="mt-20 grid gap-12 md:grid-cols-2 md:gap-16">
            <div data-testid="about-mission-card">
              <p className="text-xs uppercase tracking-wide text-steel-label">
                {t.about.mission.title}
              </p>
              <p className="mt-4 text-xl leading-snug text-silver">
                {t.about.mission.body}
              </p>
            </div>
            <div
              className="md:border-l md:border-graphite-200 md:pl-16"
              data-testid="about-vision-card"
            >
              <p className="text-xs uppercase tracking-wide text-steel-label">
                {t.about.vision.title}
              </p>
              <p className="mt-4 text-xl leading-snug text-silver">
                {t.about.vision.body}
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-graphite-200" data-testid="about-values-section">
        <div className="mx-auto max-w-7xl px-6 py-24">
          <Reveal>
            <Overline>{t.about.valuesOverline}</Overline>
            <h2 className="mt-4 text-3xl font-semibold tracking-tight text-steel-bright sm:text-4xl">
              {t.about.valuesTitle}
            </h2>
          </Reveal>

          <div className="mt-16">
            {t.about.values.map((v) => (
              <div
                key={v.n}
                className="flex flex-col gap-3 border-t border-graphite-200 py-8 last:border-b md:flex-row md:items-baseline md:gap-12"
                data-testid={`about-value-${v.n}`}
              >
                <h3 className="w-64 shrink-0 text-2xl font-semibold tracking-tight text-silver">
                  {v.title}
                </h3>
                <p className="max-w-md text-sm leading-relaxed text-steel">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTASection />
    </div>
  );
};

export default About;
